import React from 'react'

function TenderText11() {
  return (
    <embed src="\pdfs\EAT1.1.6.3_DD-VL_Variable_twist_outlet_with_guide_ring_2018_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderText11